import request from "@/utils/request";

export function saveFavorites (data){
  return request({
    url:'/osp/materialFavorites/saveOrUpdate',
    method:'post',
    data: data
  })
}

export function getFavorites (data){
  return request({
    url:'/osp/materialFavorites/list',
    method:'post',
    data: data
  })
}

export function removeByCode (data){
  return request({
    url:'/osp/materialFavorites/remove',
    method:'post',
    data: data
  })
}



